var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "q-field",
        { attrs: { "error-label": "Invalid Date" } },
        [
          !_vm.hide
            ? _c(
                "q-search",
                {
                  attrs: { placeholder: _vm.placeholder },
                  model: {
                    value: _vm.filter,
                    callback: function($$v) {
                      _vm.filter = $$v
                    },
                    expression: "filter"
                  }
                },
                [
                  _c("q-autocomplete", {
                    ref: "StudentAutoComplete",
                    attrs: {
                      debounce: 500,
                      "max-results": _vm.maxResults,
                      disable: _vm.disable
                    },
                    on: { search: _vm.onSearch, selected: _vm.onSelect }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }